import SuccessPage from '@gameday/common/components/form/Common/SuccessPage'
import { useEffect } from 'react'

import routes from '../../../../constants/routes/routes'
import { buildPath } from '../../../../utils/common'
import LoadingPage from '../../../common/LoadingPage'

const VerifyAccountComponent = ({ verifyEmailMsg, history, verifyEmail, verified, urlParams, formType }) => {
  const { email, token } = urlParams
  useEffect(() => {
    if (email && token) {
      verifyEmail({
        email,
        token,
      })
    }
  }, [])
  return verified || verifyEmailMsg ? (
    <SuccessPage
      history={history}
      headingMessage={verifyEmailMsg || 'Email successfully verified!'}
      subHeadingMessage={!verifyEmailMsg && 'Please log in to complete your registration'}
      redirectLoginPath={buildPath(formType, routes.login.path, history, urlParams)}
      hideIcon={!verified}
    />
  ) : (
    <LoadingPage label="Verifying Email" />
  )
}

export default VerifyAccountComponent
